export const scrollToBottom = () =>
  window.scrollTo({
    behavior: 'smooth',
    left: 0,
    top: document.body.scrollHeight,
  });
